import React from "react";
import { Button, Form, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { Field } from "redux-form";
import * as phases from "../../../utils/helpers/phases";
import { Trans } from "react-i18next";
export const LoginComponent = ({ handleSubmit, phase, login, t }) => (
  <Segment basic>
    <Form as="form" size="large" onSubmit={handleSubmit}>
      <Field
        name="email"
        type="e-mail"
        component={Form.Input}
        fluid
        icon="user"
        iconPosition="left"
        placeholder={t("login:emailPlaceholder")}
      />
      <Form.Field>
        <Field
          name="password"
          type="password"
          component={Form.Input}
          fluid
          icon="lock"
          iconPosition="left"
          placeholder={t("login:passwordPlaceholder")}
        />
      </Form.Field>
      <Button
        fluid
        color="orange"
        size="large"
        type="submit"
        loading={phase === phases.LOADING}
        disabled={phase === phases.LOADING}>
        {t("login:loginButton")}
      </Button>
    </Form>
    <Button
      fluid
      style={{ marginTop: 10 }}
      size="large"
      type="submit"
      inverted
      loading={phase === phases.LOADING}
      disabled={phase === phases.LOADING}
      onClick={() =>
        login({
          email: "demo",
          password: "demo"
        })
      }>
      {t("login:demoButton")}
    </Button>
    <div style={{ color: "white", marginTop: 15 }}>
      <Trans i18nKey="login:forgotPasswordText">
        Forgot password? <Link to="/forgotpassword">Reset it</Link>
      </Trans>
    </div>
    <div style={{ color: "white", marginTop: 10 }}>
      <Trans i18nKey="login:registerText">
        Don't have account?
        <Link to="/register">Create new one</Link>
      </Trans>
    </div>
  </Segment>
);



// WEBPACK FOOTER //
// ./src/users/loggedUser/Login/LoginComponent.js